__turbopack_context__.v({
  "mapImage": "StaticMap-module-scss-module__k0pdrG__mapImage",
  "showMapButton": "StaticMap-module-scss-module__k0pdrG__showMapButton",
  "staticMap": "StaticMap-module-scss-module__k0pdrG__staticMap",
});
